import React, { useState } from "react";
import "./ClearPending.css";
import { ClearPenddingTrancation } from "../../config/LiveApi";

const ClearPending = () => {
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [loading, setLoading] = useState(false);
  const [result, setResult] = useState(null);


  const convertToUTC = (date, type) => {
    if (!date) return null;

    if (type === "start") {
      return `${date}T00:00:00.000Z`;
    } else {
      return `${date}T23:59:59.999Z`;
    }
  };

  const handleSubmit = async () => {
    const startDateTime = convertToUTC(startDate, "start");
    const endDateTime = convertToUTC(endDate, "end");

    if (!startDateTime || !endDateTime) {
      alert("Please select both start and end date");
      return;
    }

    setLoading(true);
    setResult(null);

    try {
      const response = await ClearPenddingTrancation({
        startDate: startDateTime,
        endDate: endDateTime,
      });

      setResult(response);
    } catch (error) {
      setResult({
        status: false,
        message: error.message || "Something went wrong",
      });
    }

    setLoading(false);
  };

  return (
<div className="pending-container-automate">
      <h2 className="page-title-automate">Pending Payout Clearance</h2>

      <div className="card-box-automate">
        <div className="input-row-automate">
          <div className="input-group-automate">
            <label className="label-automate">Start Date</label>
            <input
              type="date"
              className="input-automate"
              value={startDate}
              onChange={(e) => setStartDate(e.target.value)}
            />
          </div>

          <div className="input-group-automate">
            <label className="label-automate">End Date</label>
            <input
              type="date"
              className="input-automate"
              value={endDate}
              onChange={(e) => setEndDate(e.target.value)}
            />
          </div>
        </div>

        <button
          className="button-automate"
          onClick={handleSubmit}
          disabled={loading}
        >
          {loading ? "Processing..." : "Clear Pending Transactions"}
        </button>
      </div>

      {result && (
        <div
          className={`result-box-automate ${
            result.status ? "result-success-automate" : "result-error-automate"
          }`}
        >
          <h3>Result:</h3>
          <p>
            <strong>Message:</strong> {result.message}
          </p>

          {result.data && (
            <div className="summary-grid-automate">
              <div>Transactions Found: {result.data.totalTransactions}</div>
              <div>Status Checked: {result.data.totalChecked}</div>
              <div>Webhook Triggered: {result.data.webhooksTriggered}</div>
              <div>Errors: {result.data.errors}</div>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default ClearPending;